module.exports = __webpack_public_path__ + "static/Modals.23c17888.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Modals.jpg
// module id = 400
// module chunks = 65579394461380